import React, { Component } from "react";
import { ElementsConsumer, PaymentElement } from "@stripe/react-stripe-js";
import { Spinner } from "react-bootstrap";
import ReservationService from "../../services/ReservationService";

class PetCleaningFeeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      isMobile: false,
      failedmessage: "",
      hasSubmitted: false,
    };
    this.removeMessage = this.removeMessage.bind(this);
    this.setPrevious = this.setPrevious.bind(this);
  }

  componentDidMount() {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    this.setState({ isMobile });
  }

  clearLocalStorage = () => {
    localStorage.removeItem("pricing");
    localStorage.removeItem("checkin");
    localStorage.removeItem("checkout");
    localStorage.removeItem("guest_email");
    localStorage.removeItem("userToken");
    localStorage.removeItem("reservationDetails");
    localStorage.removeItem("listing_slug");
    localStorage.removeItem("listing_name");
    localStorage.removeItem("queryParams");
  };

  petCleaningPayment = async (event) => {
    event.preventDefault();
    if (this.state.loader || this.state.hasSubmitted) {
      return;
    }
    this.setState({ loader: true, failedmessage: "" });

    const stripe = this.props.stripe;
    const elements = this.props.elements;

    if (!stripe || !elements) {
      this.setState({
        loader: false,
        failedmessage: "Payment is still loading. Please try again.",
      });
      return;
    }

    try {
      const result = await stripe.confirmPayment({
        elements,
        redirect: "if_required",
      });

      if (result?.error) {
        this.setState({
          failedmessage: result.error.message || "Payment failed. Please try again.",
        });
        return;
      }

      if (result?.paymentIntent?.status !== "succeeded") {
        this.setState({ failedmessage: "Payment failed. Please try again." });
        return;
      }

      const petCleaningData = {
        confirmation_code: this.props.confirmation_code,
        stripe_transaction_id: result.paymentIntent.id || this.props.stripe_id,
        amount: this.props.amount,
        no_of_pet: this.props.no_of_pet,
      };

      await ReservationService.storePetCleaning(petCleaningData);
      this.setState({ hasSubmitted: true });
      localStorage.setItem("pet_cleaning_payment", "1");
      this.clearLocalStorage();

      if (this.props.onPaymentSuccess) {
        this.props.onPaymentSuccess();
      } else {
        const baseThemeUrl = globalThis?.themeUrl || "/";
        window.location.href = `${baseThemeUrl}reservation-details`;
      }
    } catch (error) {
      this.setState({
        failedmessage: "Something went wrong while processing payment.",
      });
    } finally {
      this.setState({ loader: false });
    }
  };

  removeMessage = () => {
    this.setState({ failedmessage: "" });
  };

  setPrevious = () => {
    if (this.props.onPrevious) {
      this.props.onPrevious();
    } else {
      window.location.href = "/reservation-details";
    }
  };

  render() {
    return (
      <>
        <div>
          <span>
            <h5 className="text-danger decline">{this.state.failedmessage}</h5>
          </span>
        </div>

        <div>
          <PaymentElement onChange={this.removeMessage} />
          <div
            className={
              this.props.app_class
                ? "step_btns sign_box" + this.props.app_class
                : "step_btns sign_box"
            }
          >
            <button
              type="button"
              className="w-100 btn_pre_wzd deskview"
              disabled={this.state.loader}
              onClick={this.setPrevious}
            >
              Previous
            </button>
            {this.state.isMobile === true ? (
              <div className="pay_parking_app">
                <h5>${this.props.amount ? this.props.amount : 0}</h5>
                <p>Total</p>
              </div>
            ) : (
              ""
            )}

            <button
              type="button"
              className="btn_next_wzd"
              disabled={this.state.loader || this.state.hasSubmitted}
              onClick={(e) => this.petCleaningPayment(e)}
            >
              {this.state.loader ? (
                <>
                  Pay{" "}
                  <Spinner
                    as="span"
                    animation="grow"
                    role="status"
                    aria-hidden="true"
                    size="sm"
                  />
                </>
              ) : (
                "Pay"
              )}
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default function InjectedPetCleaningFeeForm(props) {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <PetCleaningFeeForm
          stripe={stripe}
          elements={elements}
          stripe_id={props.stripe_id}
          amount={props.amount}
          confirmation_code={props.confirmation_code}
          no_of_pet={props.no_of_pet}
          app_class={props.app_class}
          onPaymentSuccess={props.onPaymentSuccess}
          onPrevious={props.onPrevious}
        />
      )}
    </ElementsConsumer>
  );
}
